import type { AccountStatusViewDto } from '@identity/application/dtos';
import type { AccountStatus } from '@identity/domain/entities';

/**
 * Converts the account status entity into the data presentation renders.
 *
 * It copies the requirement map exactly as it arrived, unknown keys included: dropping one would
 * take the user to the end of the wizard with an incomplete account. `enforcementMode` and the three
 * optional account fields are copied the same way, so "not sent" and "sent something unknown" stay
 * distinguishable.
 */
export const mapAccountStatusToViewDto = (status: AccountStatus): AccountStatusViewDto => ({
  requirements: { ...status.requirements },
  account: {
    firstName: status.account.firstName,
    email: status.account.email,
    lastName: status.account.lastName,
    phone: status.account.phone,
    passwordChangedAt: status.account.passwordChangedAt,
  },
  enforcementMode: status.enforcementMode,
});
